import { render, staticRenderFns } from "./del.vue?vue&type=template&id=6a288b38&scoped=true&"
import script from "./del.vue?vue&type=script&lang=js&"
export * from "./del.vue?vue&type=script&lang=js&"
import style0 from "./del.vue?vue&type=style&index=0&id=6a288b38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a288b38",
  null
  
)

component.options.__file = "del.vue"
export default component.exports